import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";
import { CardDiv } from "./elements";
import makeSlug from "./../../modules/makeSlug";
import MarkdownSpan from "./../MarkdownSpan";

const Card = ({ index, id, cardData }) => {
  const mySlug = `/item/${makeSlug(
    cardData.Caption_for_Website ||
      cardData.LinkImageNumber ||
      cardData.ID ||
      id
  )}`;
  // console.log(cardData);
  return (
    <CardDiv>
      <h2>
        <Link to={mySlug}>
          <span>{cardData.LinkImageNumber || cardData.ID}</span>
        </Link>
        <Link to={mySlug}>
          <MarkdownSpan text={cardData.Caption_for_Website} />
        </Link>
      </h2>
      {cardData.Image_File &&
      cardData.Image_File.large &&
      cardData.Image_File.large.length ? (
        <Link to={mySlug}>
          <Img
            fixed={[cardData.Image_File.large[0].childImageSharp.fixed]}
            alt={cardData.Title || cardData.Full_Title}
          />
        </Link>
      ) : null}
    </CardDiv>
  );
};

export default Card;
